import { useContext, useMemo, useCallback } from 'react';
import { usePaginationContext } from './usePaginationContext.js';
import { LinkProviderContext } from '../../LinkProvider/LinkProvider.js';
import '../PaginationContext.js';
import '@emotion/react';

const usePageLinkProps = _ref => {
  let {
    pageNumber,
    onClick
  } = _ref;
  const context = usePaginationContext();
  const {
    onClick: onClickFromContext
  } = useContext(LinkProviderContext);
  const {
    setPageLinkProps
  } = context || {};
  const pageLinkProps = useMemo(() => {
    const propsFromPaginationContext = setPageLinkProps && pageNumber ? setPageLinkProps(pageNumber) : {};
    return {
      ...propsFromPaginationContext,
      onClick: propsFromPaginationContext.onClick ?? onClickFromContext
    };
  }, [pageNumber, setPageLinkProps, onClickFromContext]);
  const handleLinkClick = useCallback(e => {
    onClick();
    if (pageLinkProps != null && pageLinkProps.onClick) {
      pageLinkProps.onClick(e);
    }
  }, [onClick, pageLinkProps]);
  return {
    ...pageLinkProps,
    onClick: handleLinkClick
  };
};

export { usePageLinkProps };
